var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.602,
    height: 30.552,
    viewBox: "0 0 37.602 30.552",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.6,51.617a16.072,16.072,0,0,1-4.442,1.217,7.665,7.665,0,0,0,3.391-4.261,15.406,15.406,0,0,1-4.888,1.866,7.708,7.708,0,0,0-13.335,5.271,7.938,7.938,0,0,0,.179,1.758A21.82,21.82,0,0,1,2.618,49.405a7.711,7.711,0,0,0,2.369,10.3A7.613,7.613,0,0,1,1.5,58.759v.085A7.744,7.744,0,0,0,7.68,66.418a7.694,7.694,0,0,1-2.021.254A6.816,6.816,0,0,1,4.2,66.54a7.782,7.782,0,0,0,7.2,5.37A15.489,15.489,0,0,1,1.845,75.2,14.439,14.439,0,0,1,0,75.092a21.7,21.7,0,0,0,11.826,3.459c14.185,0,21.941-11.751,21.941-21.936,0-.341-.012-.67-.028-1A15.379,15.379,0,0,0,37.6,51.617Z",
    transform: "translate(0 -48)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.8e46109f.svg";
export { ForwardRef as ReactComponent };